module.exports = __webpack_public_path__ + "static/media/mapa.4547d9d1.jpg";